export enum ScreenshotsAuditRulesOld {
  screenshot_desktop_hd_achromatomaly = 'screenshot_desktop_hd_achromatomaly',
  screenshot_desktop_hd_achromatopsia = 'screenshot_desktop_hd_achromatopsia',
  screenshot_desktop_hd_deuteranomaly = 'screenshot_desktop_hd_deuteranomaly',
  screenshot_desktop_hd_deuteranopia = 'screenshot_desktop_hd_deuteranopia',
  screenshot_desktop_hd_protanomaly = 'screenshot_desktop_hd_protanomaly',
  screenshot_desktop_hd_protanopia = 'screenshot_desktop_hd_protanopia',
  screenshot_desktop_hd_tritanomaly = 'screenshot_desktop_hd_tritanomaly',
  screenshot_desktop_hd_tritanopia = 'screenshot_desktop_hd_tritanopia',
  screenshot_desktop_hd_full_size = 'screenshot_desktop_hd_full_size',
  screenshot_mobile_full_size = 'screenshot_mobile_full_size',
  screenshot_desktop_high_contrast = 'screenshot_desktop_high_contrast',
  screenshot_desktop_grayscale = 'screenshot_desktop_grayscale',
  screenshot_desktop_invert = 'screenshot_desktop_invert',
  screenshot_desktop_invert_grayscale = 'screenshot_desktop_invert_grayscale',
  screenshot_desktop_yellow_on_black = 'screenshot_desktop_yellow_on_black',
}

export enum ScreenshotAuditRulesNew {
  screenshot_full_size = 'screenshot_full_size',
  screenshot_achromatomaly = 'screenshot_achromatomaly',
  screenshot_achromatopsia = 'screenshot_achromatopsia',
  screenshot_deuteranomaly = 'screenshot_deuteranomaly',
  screenshot_deuteranopia = 'screenshot_deuteranopia',
  screenshot_protanomaly = 'screenshot_protanomaly',
  screenshot_protanopia = 'screenshot_protanopia',
  screenshot_tritanomaly = 'screenshot_tritanomaly',
  screenshot_tritanopia = 'screenshot_tritanopia',
  screenshot_high_contrast = 'screenshot_high_contrast',
  screenshot_grayscale = 'screenshot_grayscale',
  screenshot_invert = 'screenshot_invert',
  screenshot_invert_grayscale = 'screenshot_invert_grayscale',
  screenshot_yellow_on_black = 'screenshot_yellow_on_black',
}

export const ScreenshotsAuditRules = {
  ...ScreenshotsAuditRulesOld,
  ...ScreenshotAuditRulesNew,
};

export enum AccessibilityAuditRules {
  accessible_svg = 'accessible_svg',
  alt_color_convey_information = 'alt_color_convey_information',
  animation = 'animation',
  applet_missing_alt = 'applet_missing_alt',
  applet_missing_body = 'applet_missing_body',
  area_missing_alt = 'area_missing_alt',
  aria_describedby_association = 'aria_describedby_association',
  aria_hidden_false = 'aria_hidden_false',
  aria_labelledby_association = 'aria_labelledby_association',
  audio_alternative = 'audio_alternative',
  audio_video_captions = 'audio_video_captions',
  autoplay_audio_video = 'autoplay_audio_video',
  blink_element = 'blink_element',
  capital_letters_words = 'capital_letters_words',
  captcha_google = 'captcha_google',
  click_verb = 'click_verb',
  color_contrast_aa = 'color_contrast_aa',
  color_contrast_aaa = 'color_contrast_aaa',
  color_contrast_state_pseudo_classes_active = 'color_contrast_state_pseudo_classes_active',
  color_contrast_state_pseudo_classes_hover = 'color_contrast_state_pseudo_classes_hover',
  color_contrast_state_pseudo_classes_focus = 'color_contrast_state_pseudo_classes_focus',
  content_editable_missing_attributes = 'content_editable_missing_attributes',
  contentinfo_landmark_only_one = 'contentinfo_landmark_only_one',
  css_images_convey_information = 'css_images_convey_information',
  duplicated_for_attribute = 'duplicated_for_attribute',
  duplicated_id_attribute = 'duplicated_id_attribute',
  elements_not_allowed_in_head = 'elements_not_allowed_in_head',
  empty_label_element = 'empty_label_element',
  empty_link_element = 'empty_link_element',
  empty_title_attribute = 'empty_title_attribute',
  fieldset_no_legend = 'fieldset_no_legend',
  flash_content = 'flash_content',
  font_style_italic = 'font_style_italic',
  general_alt = 'general_alt',
  group_elements_name_attribute = 'group_elements_name_attribute',
  h1_must_be = 'h1_must_be',
  h1_only_one = 'h1_only_one',
  headings_hierarchy = 'headings_hierarchy',
  headings_sibling_unique = 'headings_sibling_unique',
  hidden_content = 'hidden_content',
  horizontal_rule = 'horizontal_rule',
  html_lang_attr = 'html_lang_attr',
  img_adjacent_duplicate_text_link = 'img_adjacent_duplicate_text_link',
  img_alt_duplicate_text_link = 'img_alt_duplicate_text_link',
  img_empty_alt_in_link = 'img_empty_alt_in_link',
  img_empty_alt_with_empty_title = 'img_empty_alt_with_empty_title',
  incorrect_label_placement = 'incorrect_label_placement',
  incorrect_technique_for_hiding_content = 'incorrect_technique_for_hiding_content',
  invalid_aria_role = 'invalid_aria_role',
  invalid_attribute_dir_value = 'invalid_attribute_dir_value',
  label_duplicated_content_title = 'label_duplicated_content_title',
  label_implicitly_associated = 'label_implicitly_associated',
  label_inappropriate_association = 'label_inappropriate_association',
  label_visually_hidden_only = 'label_visually_hidden_only',
  legend_first_child_of_fieldset = 'legend_first_child_of_fieldset',
  link_button_space_key = 'link_button_space_key',
  link_with_unclear_purpose = 'link_with_unclear_purpose',
  links_language_destination = 'links_language_destination',
  links_new_window_mark = 'links_new_window_mark',
  links_same_content_different_url = 'links_same_content_different_url',
  main_element_only_one = 'main_element_only_one',
  main_landmark_must_be_top_level = 'main_landmark_must_be_top_level',
  meaningful_content_sequence = 'meaningful_content_sequence',
  minimum_font_size = 'minimum_font_size',
  missing_alt_attribute = 'missing_alt_attribute',
  missing_href_on_a = 'missing_href_on_a',
  missing_label = 'missing_label',
  missing_submit_button = 'missing_submit_button',
  misused_aria_on_focusable_element = 'misused_aria_on_focusable_element',
  misused_input_attribute = 'misused_input_attribute',
  misused_required_attribute = 'misused_required_attribute',
  misused_tabindex_attribute = 'misused_tabindex_attribute',
  no_empty_header = 'no_empty_header',
  no_headers = 'no_headers',
  no_meta_http_equiv_refresh = 'no_meta_http_equiv_refresh',
  object_general_alt = 'object_general_alt',
  object_missing_body = 'object_missing_body',
  orientation = 'orientation',
  outline_zero = 'outline_zero',
  position_sticky = 'position_sticky',
  positive_tabindex = 'positive_tabindex',
  role_application = 'role_application',
  rtl_content = 'rtl_content',
  select_initial_option = 'select_initial_option',
  table_caption_summary_identical = 'table_caption_summary_identical',
  table_missing_description = 'table_missing_description',
  table_row_and_column_headers = 'table_row_and_column_headers',
  text_color_convey_information = 'text_color_convey_information',
  title_element = 'title_element',
  title_for_abbr = 'title_for_abbr',
  title_iframe = 'title_iframe',
  unclear_uri_on_a = 'unclear_uri_on_a',
  video_audio_descriptions = 'video_audio_descriptions',
  zoom_disabled = 'zoom_disabled',
}

// These are non info severity rules
export enum AccessibilityWaveAuditRules {
  alt_missing = 'alt_missing',
  alt_link_missing = 'alt_link_missing',
  alt_spacer_missing = 'alt_spacer_missing',
  alt_input_missing = 'alt_input_missing',
  alt_area_missing = 'alt_area_missing',
  alt_map_missing = 'alt_map_missing',
  longdesc_invalid = 'longdesc_invalid',
  label_missing = 'label_missing',
  label_empty = 'label_empty',
  label_multiple = 'label_multiple',
  aria_reference_broken = 'aria_reference_broken',
  aria_menu_broken = 'aria_menu_broken',
  title_invalid = 'title_invalid',
  language_missing = 'language_missing',
  meta_refresh = 'meta_refresh',
  heading_empty = 'heading_empty',
  button_empty = 'button_empty',
  link_empty = 'link_empty',
  link_skip_broken = 'link_skip_broken',
  th_empty = 'th_empty',
  blink = 'blink',
  marquee = 'marquee',
  contrast = 'contrast',
}

// These findings are used to determine passed values for AccessibilityWaveAuditRules.
// If these show up in the AuditFindings it means the corresponding Rule has a passed element
// As such they also help determine if an AccessibilityWaveAuditRules was triggered
export enum AccessibilityWaveAuditFindings {
  alt = 'alt',
  alt_null = 'alt_null',
  alt_link = 'alt_link',
  alt_spacer = 'alt_spacer',
  alt_input = 'alt_input',
  alt_area = 'alt_area',
  alt_map = 'alt_map',
  longdesc = 'longdesc',
  label = 'label',
  aria_label = 'aria_label',
  aria_describedby = 'aria_describedby',
  aria_menu = 'aria_menu',
  lang = 'lang',
  h1 = 'h1',
  h2 = 'h2',
  h3 = 'h3',
  h4 = 'h4',
  h5 = 'h5',
  h6 = 'h6',
  link_skip = 'link_skip',
  th = 'th',
  th_col = 'th_col',
  th_row = 'th_row',
}

// These are AccessibilityWaveAuditFindings that are also rules in themselves
export const findingsThatAreAlsoRules: AccessibilityWaveAuditFindings[] = [
  AccessibilityWaveAuditFindings.aria_label,
  AccessibilityWaveAuditFindings.aria_describedby,
  AccessibilityWaveAuditFindings.aria_menu,
];

// This mapping shows the relation between AccessibilityWaveAuditRules and AccessibilityWaveAuditFindings.
// This shows which Findings trigger/pass which Rules
export const AccessibilityWaveAuditRuleTriggerMapping: Record<
  AccessibilityWaveAuditFindings,
  Array<AccessibilityWaveAuditRules>
> = {
  [AccessibilityWaveAuditFindings.alt]: [AccessibilityWaveAuditRules.alt_missing],
  [AccessibilityWaveAuditFindings.alt_null]: [AccessibilityWaveAuditRules.alt_missing],
  [AccessibilityWaveAuditFindings.alt_link]: [AccessibilityWaveAuditRules.alt_link_missing],
  [AccessibilityWaveAuditFindings.alt_spacer]: [AccessibilityWaveAuditRules.alt_spacer_missing],
  [AccessibilityWaveAuditFindings.alt_input]: [AccessibilityWaveAuditRules.alt_input_missing],
  [AccessibilityWaveAuditFindings.alt_area]: [AccessibilityWaveAuditRules.alt_area_missing],
  [AccessibilityWaveAuditFindings.alt_map]: [AccessibilityWaveAuditRules.alt_map_missing],
  [AccessibilityWaveAuditFindings.longdesc]: [AccessibilityWaveAuditRules.longdesc_invalid],
  [AccessibilityWaveAuditFindings.label]: [
    AccessibilityWaveAuditRules.label_multiple,
    AccessibilityWaveAuditRules.label_missing,
    AccessibilityWaveAuditRules.label_empty,
  ],
  [AccessibilityWaveAuditFindings.aria_label]: [AccessibilityWaveAuditRules.aria_reference_broken],
  [AccessibilityWaveAuditFindings.aria_describedby]: [AccessibilityWaveAuditRules.aria_reference_broken],
  [AccessibilityWaveAuditFindings.aria_menu]: [AccessibilityWaveAuditRules.aria_menu_broken],
  [AccessibilityWaveAuditFindings.lang]: [AccessibilityWaveAuditRules.language_missing],
  [AccessibilityWaveAuditFindings.h1]: [AccessibilityWaveAuditRules.heading_empty],
  [AccessibilityWaveAuditFindings.h2]: [AccessibilityWaveAuditRules.heading_empty],
  [AccessibilityWaveAuditFindings.h3]: [AccessibilityWaveAuditRules.heading_empty],
  [AccessibilityWaveAuditFindings.h4]: [AccessibilityWaveAuditRules.heading_empty],
  [AccessibilityWaveAuditFindings.h5]: [AccessibilityWaveAuditRules.heading_empty],
  [AccessibilityWaveAuditFindings.h6]: [AccessibilityWaveAuditRules.heading_empty],
  [AccessibilityWaveAuditFindings.link_skip]: [AccessibilityWaveAuditRules.link_skip_broken],
  [AccessibilityWaveAuditFindings.th]: [AccessibilityWaveAuditRules.th_empty],
  [AccessibilityWaveAuditFindings.th_col]: [AccessibilityWaveAuditRules.th_empty],
  [AccessibilityWaveAuditFindings.th_row]: [AccessibilityWaveAuditRules.th_empty],
};
